import { t } from 'i18next';

import { company } from '~/company/Company';

const config = () => ({
  stepsData: [
    {
      textTitle: t('onboarding:storrd:everydayShopping:title'),
      textDescription: t('onboarding:storrd:everydayShopping:description'),
      position: 'top',
    },
    {
      textTitle: t('onboarding:storrd:shopByOccasion:title'),
      textDescription: t('onboarding:storrd:shopByOccasion:description'),
      position: 'top',
    },
    {
      textTitle: t('onboarding:storrd:bundlePricing:title'),
      textDescription: t('onboarding:storrd:bundlePricing:description'),
      position: 'top',
    },
    {
      textTitle: t('onboarding:storrd:fastDelivery:title'),
      textDescription: t('onboarding:storrd:fastDelivery:description'),
      position: 'top',
    },
    {
      textTitle: t('onboarding:storrd:weeklyDiscounts:title'),
      textDescription: t('onboarding:storrd:weeklyDiscounts:description'),
      position: 'top',
    },
    {
      textTitle: t('onboarding:storrd:signUp:title'),
      textDescription: t('onboarding:storrd:signUp:description'),
      position: 'top',
    },
  ],
  additionalData: {
    backgroundColor: 'var(--layer-floor-0-brand-subtle)',
    isVisibleInputLabels: true,
  },
});

export default () => ({
  ...config(),
  stepsData: config().stepsData.map((configItem, index) => ({
    ...configItem,
    img: company.images.onboarding?.[index] || '',
  })),
});
